const _legacy = require('./legacy');
const _shades_classic = require('./shades-classic');
const _shades_grey = require('./shades-grey');
const _rect = require('./rect');

module.exports = {
    legacy: _legacy,
    shades_classic: _shades_classic,
    shades_grey: _shades_grey,
    rect: _rect
};